import { yupResolver } from "@hookform/resolvers/yup";
import { createColumnHelper } from "@tanstack/react-table";
import { Fragment, useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom"; //M10-9862
import downArrow from "src/assets/down-arrow.svg";
import { Button, Input, Modal, Toggle } from "src/components";
import Loader from "src/components/ui/loader.component";
import VersioningCrate from "src/components/Versioning/versioningModal.component";
import { flattenObject, generateUniqueID } from "src/constants/functions";
import { invoiceActions } from "src/context/invoice-slice";
import { RootState } from "src/context/store";
import { useEventStatus } from "src/hooks/useEventStatus";
import { useOutsideClick } from "src/hooks/useOutsideClick";
import { toast } from "src/hooks/useToast";
import {
  entryInvoice,
  getCheckFullyInvoiced, //M10-10639
  getInvoiceActionAllowed,
  getInvoiceBatchList,
  getInvoiceChangeValidationV1,
  getInvoiceDetails,
  getInvoicePriceList,
  getOrderedProducts,
  getProductGstDetails,
  getSimilarCompanyProducts,
  postInvoiceRemark,
  rejectionReviewAction,
} from "src/services/invoice-api";
import Book from "../../assets/book.png";
import DeleteIcon from "../../assets/delete.svg";
import editPen from "src/assets/edit-pen.svg";
import PurpleLeftArrowIcon from "../../assets/purple-left-arrow.svg";
import SubTable from "../counter-details/sub-table.component";
import { generate5CharCode, getFinancialYear, getInvoiceDetailsInfo, isPriceExceedingPtr } from "../invoice-master/invoice-helper";  // M10-14735 M10-15166
import InvoiceLayout from "../invoice-master/invoice-layout.component";
import InvoiceDetailCard from "./invoice-detail.component";
import { Transition } from "@headlessui/react";
import { MessageCircle, MessageSquareText } from "lucide-react";
import InvoiceRemarks from "./InvoiceRemarks";
import InvoiceEntryForm from "./InvoiceEntryCards/InvoiceEntryForm";
import { priceIdentifierList } from "./invoice-constants";
import { schema } from "./invoice-constants";
import { validateInvoiceProducts } from "./InvoiceEntryCards/InvoiceEntryUtility";
import EwayDetails from "./InvoiceEntryCards/EwayDetails";
import useDebounceLeading from "src/hooks/useDebounceLeading";
import { fineGrainedPermissionsKeys } from "src/constants/permission";
import usePermission from "src/hooks/usePermission";
import crossIcon from "src/assets/cross.svg";
import AddFeedbackForm from "../feedback/add-feedback-form.component";
import { addFeedback } from "src/services/feedback-api";
import InvoiceReject from "./invoice-reject";
import BrandConflictModal, { BrandConflictMatch } from "./brand-conflict-modal";//M10-15822

const columnHelper = createColumnHelper();

interface selectedPriceIdentifier {
  key: string;
  description: string;
  priceldentifier_id: number;
}

export const InvoiceEntryScreen = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [cashDiscountPercent, setCashDiscountPercent] = useState(0);
  const [cashDiscountAmount, setCashDiscountAmount] = useState(0);
  const { invoiceDetails, invoicesTextractData } = useSelector((state: RootState) => state.invoice);
  const [selectedPriceIdentifier, setSelectedPriceIdentifier] = useState<selectedPriceIdentifier>({
    key: "",
    description: "",
    priceldentifier_id: 0,
  });
  const [quantity, setQuantity] = useState<number>(0);
  const [discountPercentage, setDiscountPercentage] = useState<number>(0);
  const [discountAmount, setDiscountAmount] = useState<number>(0);
  const [price, setPrice] = useState<number>(0);
  const [useOrderedProducts, setUseOrderedProducts] = useState("ordered");
  const [itemCode, setItemCode] = useState<string>("");
  const [priceList, setPriceList] = useState<any[]>([]);
  const [batchList, setBatchList] = useState<any[]>([]);
  const [gstAmbiguous, setGstAmbiguous] = useState<boolean>(false);
  const [isConfirmingInvoice, setConfirmingInvoice] = useState<boolean>(false);
  const [netInvoiceAmount, setNetInvoiceAmount] = useState<string>(invoiceDetails?.invoice?.net_amount);
  const [selectedBatch, setSelectedBatch] = useState<any>({});
  const [mappedData, setMappedData] = useState<any[]>([]);
  const [tcs, setTcs] = useState<number>(0);
  const [fetchTrigger, setFetchTrigger] = useState(0);
  const [VersioningModal, setVersioningModal] = useState(false);
  const [unknownBatch, setUnknownBatch] = useState<any[]>([]);
  const outSideClickRef = useOutsideClick(() => {
    setVersioningModal(false);
  });
  const [isRemarksShown, setIsRemarksShown] = useState(false);
  const [editingTextractProduct, setEditingTextractProduct] = useState<any>({});
  const [editingProductId, setEditingProductId] = useState<any>(null);
  const [isEditingProduct, setIsEditingProduct] = useState<boolean>(false); // keep entered Price when MRP is changed during edit
  const [isEwayApplicable, setIsEwayApplicable] = useState(false);
  const [isEwayExempt, setEwayExempt] = useState(false);
  const ref = useOutsideClick(() => {
    setIsRemarksShown(false);
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isApprovalCheck, setIsApprovalCheck] = useState(true);
  const [invalidItem, setInvalidItem] = useState<any[]>([]);

  //M10-10639
  const [isModalSOAOpen, setIsModalSOAOpen] = useState(false);
  const [isSaoData, setIsSaoData] = useState<any[]>([]);
  const [isSaoCheck, setIsSaoCheck] = useState<boolean>(false);
  //M10-10639
  const [isNetAmount, setIsNetAmount] = useState<any>({ status: false, confirm: false }); //netAmount=0
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  //M10-12866
  const [counterCompanyLocation, setCounterCompanyLocation] = useState('');
  const [isKam, setIsKam] = useState(false);
  //M10-12866

  const { hasPermission: viewRemarks } = usePermission({
    module: fineGrainedPermissionsKeys.INVOICE.VIEWREMARKS.module,
    action: fineGrainedPermissionsKeys.INVOICE.VIEWREMARKS.action,
  });

  //M10-9862
  const location = useLocation();
  // Fall back to the company_code stored in localStorage when opened in a new
  // tab (react-router location.state is not available across a fresh tab load).
  const { CompanyCode: companyCodeFromState, fuidRejectionReviewMode, viewOnly } = location.state || {};
  const CompanyCode = companyCodeFromState || window.localStorage.getItem("company_code");

  const company_code = invoiceDetails?.company_code || CompanyCode;

  const navigate = useNavigate();

  // REJECTION-REVIEW-WORKFLOW: see handlers below `useParams`.
  const isInRejectionReview = !!(invoiceDetails?.is_rejection_pending || fuidRejectionReviewMode);
  const [reviewActionInProgress, setReviewActionInProgress] = useState<"accept" | "reject" | null>(null);
  const [reviewModalAction, setReviewModalAction] = useState<"ACCEPT" | "REJECT" | null>(null);
  // RE-EDIT-action modal: lets the reviewer edit the existing rejection
  // (rejection_code + mandatory inputs) without going through the full reject pipeline.
  const [isRejectionReEditOpen, setIsRejectionReEditOpen] = useState(false);
  const [reviewReferenceNumber, setReviewReferenceNumber] = useState<string>("");
  //M10-15822 — populated only when OMS blocks the confirm on an "Others" brand conflict
  const [brandConflictMatches, setBrandConflictMatches] = useState<BrandConflictMatch[]>([]);

  const [isAcknowledged, setIsAcknowledged] = useState(false);
  const isSpecialStockist = [invoiceDetails]?.some(
    (item: any) => ["PH7029", "PH7306"]?.includes(item?.stockist_medvol_code)
  );

  const smartFormInstance = useForm({
    // @ts-ignore
    resolver: yupResolver(schema),
    mode: "onBlur",
    defaultValues: structuredClone({}),
  });

  const { withEventCheck, isBlocked: isInvoiceEventBlocked } = useEventStatus();  // same blocked-stream banner as InvoiceApprovalScreen
  const dispatch = useDispatch();
  const { stockist_invoice_attachment_id } = useParams();
  const { idTokenDetails } = useSelector((state: RootState) => state.auth);

  // REJECTION-REVIEW-WORKFLOW: reviewer-side accept/reject handlers.
  const fetchInvoiceForReview = async () => {
    if (!stockist_invoice_attachment_id) return;
    const res = await getInvoiceDetails(stockist_invoice_attachment_id, true, company_code);
    dispatch(invoiceActions.setInvoiceDetails(res?.data));
  };

  const runReviewAction = async (action: "ACCEPT" | "REJECT") => {
    if (reviewActionInProgress) return;
    // REJECT (Incorrect Rejection) still requires a reference number via the modal.
    // ACCEPT (Correct Rejection) is called directly without a reference number.
    if (action === "REJECT" && !reviewReferenceNumber.trim()) {
      toast({ description: "Reference number is required", variant: "destructive" });
      return;
    }
    setReviewActionInProgress(action === "ACCEPT" ? "accept" : "reject");
    try {
      const reference_number = reviewReferenceNumber.trim();
      const stockistId = Number(stockist_invoice_attachment_id);
      const invoiceId = invoiceDetails?.invoice?.invoice_id;

      const reviewResponse = await rejectionReviewAction(
        {
          stockist_invoice_attachment_id: stockistId,
          action,
          ...(reference_number ? { reference_number } : {}),
        },
        company_code,
      );

      await withEventCheck(
        async () => { },
        reviewResponse?.data?.data?.eventStreamCreated?.streamId,
        company_code,
      );

      const payloadRemarks = {
        data: {
          invoice_remarks_hdr: 22,
          invoice_id: invoiceId ? invoiceId : null,
          stockist_invoice_attachment_id: stockistId,
          freetxt_remarks: reference_number ? `${action} - ${reference_number}` : action,
          remarkby_type: idTokenDetails?.["custom:role"],
          is_private: false,
        },
        primary_key: stockistId,
        event_type: "STOCKIST_INVOICE_REMARK_ADD",
      };
      await postInvoiceRemark(payloadRemarks, company_code);

      toast({
        description:
          action === "ACCEPT"
            ? "Rejection accepted. Invoice marked as rejected."
            : "Rejection overturned. Invoice returned to original user.",
        variant: "default",
      });
      setReviewModalAction(null);
      setReviewReferenceNumber("");
      await fetchInvoiceForReview();
      navigate("/transactions/invoice/0");
    } catch (error: any) {
      console.error(`rejectionReviewAction (${action}) failed:`, error);
      toast({
        description:
          error?.response?.data?.message ||
          (action === "ACCEPT" ? "Failed to accept rejection review" : "Failed to reject rejection review"),
        variant: "destructive",
      });
    } finally {
      setReviewActionInProgress(null);
    }
  };

  const openReviewModal = (action: "ACCEPT" | "REJECT") => {
    setReviewReferenceNumber("");
    setReviewModalAction(action);
  };

  const closeReviewModal = () => {
    if (reviewActionInProgress) return;
    setReviewModalAction(null);
    setReviewReferenceNumber("");
  };

  const handleAcceptRejection = () => runReviewAction("ACCEPT");
  const handleRejectRejection = () => openReviewModal("REJECT");

  const columns = [
    // //M10-9670 Start
    // columnHelper.accessor("sno", {
    //   header: "S.No",
    //   cell: (info: any) => info.row.index + 1,
    // }), //M10-9670 End
    columnHelper.accessor("item_description", {
      header: "Item Name",
      cell: (info: any) => info.row.original.item_description || "-",
    }),
    columnHelper.accessor("item_code", {
      header: "Item Code",
      cell: (info: any) => info.row.original.item_code || "-",
    }),
    columnHelper.accessor("inv_mrp", {
      header: "Inv. MRP",
      cell: (info: any) => info.row.original.inv_mrp || "0",
    }),
    columnHelper.accessor("inv_rate", {
      header: "Inv. Rate",
      cell: (info: any) => info.row.original.inv_rate || "-",
    }),
    columnHelper.accessor("ptr", {
      header: "Inv. PTR",
      cell: (info: any) => info.row.original.ptr || "0",
    }),
    columnHelper.accessor("quantity", {
      header: "Qty.",
      cell: (info: any) => info.row.original.quantity || "0",
    }),
    columnHelper.accessor("free_qty", {
      header: "Free Qty",
      cell: (info: any) => info.row.original.free_qty || "0",
    }),
    columnHelper.accessor("gross_amt", {
      header: "Gross Amt.",
      cell: (info: any) => info.row.original.gross_amt || "0",
    }),
    columnHelper.accessor("discount_type", {
      header: "Discount Defined By",
      cell: (info: any) => info.row.original.discount_type || "-",
    }),
    columnHelper.accessor("discount_amt", {
      header: "Discount %",
      cell: (info: any) => {
        const { discount_amt, inv_rate, quantity, discount_perc,p_cash_discount_perc } = info.row.original;
        if (!quantity || quantity === 0 || !inv_rate || Number(inv_rate) == 0) return "0.00";
        let discountPercent: number | string = Number(discount_perc) ? Number(discount_perc) : ((Number(discount_amt) / (Number(inv_rate) * Number(quantity))) * 100); //M10-10769
        const allDiscountPercent = Array.isArray(mappedData) && mappedData?.every((m: any) => m?.discount_type === "Discount Percent");
        if (Number(discount_perc) && Number(p_cash_discount_perc) && allDiscountPercent) {
          discountPercent = Number(discount_perc) + Number(p_cash_discount_perc) * (100 - Number(discount_perc)) / 100;
        }
        return Number(discountPercent).toFixed(2);
      },
    }),

    columnHelper.accessor("gst", {
      header: "GST %",
      cell: (info: any) => info.row.original.gst || info.row.original.p_gst_perc || "0",
    }),
    columnHelper.accessor("batch_no", {
      header: "Batch No.",
      cell: (info: any) => info.row.original.batch_no || "-",
    }),
    columnHelper.accessor("action", {
      header: "Action",
      cell: (info: any) => {
        const handleDelete = async (uniqueKey: string) => {
          setMappedData((prev) => prev.filter((item: any) => item?.unique_key !== uniqueKey));
        };
        return (
          <Button onClick={() => handleDelete(info.row.original.unique_key)}>
            <img src={DeleteIcon} alt="delete" className="w-4 h-4" />
          </Button>
        );
      },
    }),
    columnHelper.accessor("Edit", {
      header: "Edit",
      cell: (info: any) => {
        const handleEdit = async (uniqueKey: string) => {
          const { setValue }: any = smartFormInstance;
          setEditingProductId(info.row.original.invoice_product_id);
          setIsEditingProduct(true);
          setValue("itemName", info.row.original.item_description);
          setValue("itemCode", info.row.original.item_code);
          // setValue("mrp", value?.mrp || "");
          // setValue("price", value?.ptr || "");
          setPrice(info.row.original.inv_rate);
          setValue("batchNo", info.row.original.batch_no);
          setValue("discountAmount", info.row.original.discount_amt);
          setValue("discountPercentage", Number(info.row.original.discount_perc));
          setValue("freeQty", Number(info.row.original.free_qty));
          setValue("quantity", info.row.original.quantity);
          setValue("schemeType", info.row.original.discount_type);
          // const res = await getInvoicePriceList(info.row.original.item_code);
          setValue(
            "gst",
            Number(info.row.original.p_gst_perc) > 0 ? info.row.original.p_gst_perc : Number(info.row.original.gst) > 0 ? info.row.original.gst : "0"
          );
          setValue("itemPrice", { mrp: info.row.original.inv_mrp, ptr: info.row.original.ptr });
          setValue("price", Number(info.row.original.inv_rate));
          setValue("mrp", Number(info.row.original.inv_mrp));
          setValue("ptr", info.row.original.ptr);
          setValue("pts", info.row.original.pts); //M10-10856
          setSelectedBatch(info.row.original.batch_no);
          setQuantity(info.row.original.quantity);
          setDiscountPercentage(Number(info.row.original.discount_perc));
          setDiscountAmount(Number(info.row.original.discount_amt));

          if (info.row.original.discount_type === "Scheme") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 3,
              description: "Scheme",
              key: "SCHEME",
            });
            setValue("schemeType", {
              priceldentifier_id: 3,
              description: "Scheme",
              key: "SCHEME",
            });
          } else if (info.row.original.discount_type === "Discount Percent") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 1,
              description: "Discount Percent",
              key: "DISCOUNT_PERCENT",
            });
            setValue("schemeType", {
              priceldentifier_id: 1,
              description: "Discount Percent",
              key: "DISCOUNT_PERCENT",
            });
          } else if (info.row.original.discount_type === "Discount Amount") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 2,
              description: "Discount Amount",
              key: "DISCOUNT_AMOUNT",
            });
            setValue("schemeType", {
              priceldentifier_id: 2,
              description: "Discount Amount",
              key: "DISCOUNT_AMOUNT",
            });
          }

          setItemCode(info.row.original.item_code);
          setMappedData((prev) => prev.filter((item: any) => item?.unique_key !== uniqueKey));
        };
        return (
          <Button
            onClick={() => {
              setEditingTextractProduct(info.row.original);
              handleEdit(info.row.original.unique_key);
              scrollToInvoiceDetails();
            }}
          >
            <img src={editPen} alt="delete" className="w-4 h-4" />
          </Button>
        );
      },
    }),
  ];
  const columns2 = [
    // //M10-9670 Start
    // columnHelper.accessor("sno", {
    //   header: "S.No",
    //   cell: (info: any) => info.row.index + 1,
    // }), //M10-9670 End
    columnHelper.accessor("item_description", {
      header: "Item Name",
      cell: (info: any) => info.row.original.item_description || "-",
    }),
    columnHelper.accessor("item_code", {
      header: "Item Code",
      cell: (info: any) => info.row.original.item_code || "-",
    }),
    columnHelper.accessor("inv_mrp", {
      header: "Inv. MRP",
      cell: (info: any) => info.row.original.inv_mrp > 0 ? info.row.original.inv_mrp : info.row.original.textract_mrp||"0",
    }),
    columnHelper.accessor("ptr", {
      header: "Inv. PTR",
      cell: (info: any) => { //M10-13518
        const { ptr, inv_rate } = info.row.original;
        return ptr == 0 ? inv_rate : ptr; // loose equality handles both 0 and "0"
      }
      // M10-13518
    }),
    columnHelper.accessor("quantity", {
      header: "Qty.",
      cell: (info: any) => info.row.original.quantity || "0",
    }),
    columnHelper.accessor("gross_amt", {
      header: "Gross Amt.",
      cell: (info: any) => info.row.original.gross_amt || "0",
    }),
    columnHelper.accessor("discount_type", {
      header: "Discount Defined By",
      cell: (info: any) => info.row.original.discount_type || "-",
    }),
    columnHelper.accessor("discount_amt", {
      header: "Discount %",
      cell: (info: any) => {
        const { discount_amt, inv_rate, quantity } = info.row.original;
        if (!quantity || quantity === 0 || !inv_rate) return "0.00";
        const discountPercent = (discount_amt / (inv_rate * quantity)) * 100;
        return discountPercent.toFixed(2);
      },
    }),

    columnHelper.accessor("free_qty", {
      header: "Free Qty",
      cell: (info: any) => info.row.original.free_qty || "0",
    }),

    columnHelper.accessor("gst", {
      header: "GST %",
      cell: (info: any) => info.row.original.gst || info.row.original.p_gst_perc || "0",
    }),
    columnHelper.accessor("batch_no", {
      header: "Batch No.",
      cell: (info: any) => info.row.original.batch_no || "-",
    }),
    columnHelper.accessor("action", {
      header: "Action",
      cell: (info: any) => {
        const handleDelete = async (uniqueKey: string) => {
          setMappedData((prev) => prev.filter((item: any) => item?.unique_key !== uniqueKey));
        };
        return (
          <Button onClick={() => handleDelete(info.row.original.unique_key)}>
            <img src={DeleteIcon} alt="delete" className="w-4 h-4" />
          </Button>
        );
      },
    }),
    columnHelper.accessor("Edit", {
      header: "Edit",
      cell: (info: any) => {
        const handleEdit = async (uniqueKey: string) => {
          const { setValue }: any = smartFormInstance;
          setUseOrderedProducts("unknown");
          setEditingProductId(info.row.original.invoice_product_id);
          setIsEditingProduct(true);
          setValue("itemName", info.row.original.item_description);
          setValue("itemCode", info.row.original.item_code || generate5CharCode());
          // setValue("mrp", value?.mrp || "");
          // setValue("price", value?.ptr || "");
          setPrice(info.row.original.inv_rate);
          setValue("batchNo", info.row.original.batch_no);
          setValue("discountAmount", info.row.original.discount_amt);
          setValue("discountPercentage", Number(info.row.original.discount_perc));
          setValue("freeQty", Number(info.row.original.free_qty));
          setValue("quantity", info.row.original.quantity);
          setValue("schemeType", info.row.original.discount_type);
          // const res = await getInvoicePriceList(info.row.original.item_code);
          setValue(
            "gst",
            Number(info.row.original.p_gst_perc) > 0 ? info.row.original.p_gst_perc : Number(info.row.original.gst) > 0 ? info.row.original.gst : "0"
          );
          //M10-14155: unknown product edit — textract_mrp holds (MRP - PTR), inv_rate holds PTR
          //M10-14155: unknown product edit — prefer inv_mrp/ptr; fall back to textract_mrp/inv_rate when 0
          {
            const mrpValue = Number(info.row.original.inv_mrp) > 0 ? info.row.original.inv_mrp : info.row.original.textract_mrp;
            const ptrValue = Number(info.row.original.ptr) > 0 ? info.row.original.ptr : info.row.original.inv_rate;
            setValue("itemPrice", { mrp: mrpValue, ptr: ptrValue });
            setValue("price", Number(info.row.original.inv_rate));
            setValue("mrp", Number(mrpValue || 0));
            setValue("ptr", Number(ptrValue || 0));
          }
          setValue("pts", info.row.original.pts); //M10-10856
          setSelectedBatch(info.row.original.batch_no);
          setQuantity(info.row.original.quantity);
          setDiscountPercentage(Number(info.row.original.discount_perc));
          setDiscountAmount(Number(info.row.original.discount_amt));

          if (info.row.original.discount_type === "Scheme") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 3,
              description: "Scheme",
              key: "SCHEME",
            });
            setValue("schemeType", {
              priceldentifier_id: 3,
              description: "Scheme",
              key: "SCHEME",
            });
          } else if (info.row.original.discount_type === "Discount Percent") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 1,
              description: "Discount Percent",
              key: "DISCOUNT_PERCENT",
            });
            setValue("schemeType", {
              priceldentifier_id: 1,
              description: "Discount Percent",
              key: "DISCOUNT_PERCENT",
            });
          } else if (info.row.original.discount_type === "Discount Amount") {
            setSelectedPriceIdentifier({
              priceldentifier_id: 2,
              description: "Discount Amount",
              key: "DISCOUNT_AMOUNT",
            });
            setValue("schemeType", {
              priceldentifier_id: 2,
              description: "Discount Amount",
              key: "DISCOUNT_AMOUNT",
            });
          }

          setItemCode(info.row.original.item_code);
          setMappedData((prev) => prev.filter((item: any) => item?.unique_key !== uniqueKey));
        };
        return (
          <Button
            onClick={() => {
              setEditingTextractProduct(info.row.original);
              handleEdit(info.row.original.unique_key);
              scrollToInvoiceDetails();
            }}
          >
            <img src={editPen} alt="delete" className="w-4 h-4" />
          </Button>
        );
      },
    }),
  ];

  const handleAddProduct = async (data: any) => {
    // M10-14735: Free Qty / Discount % / Discount Amount are not allowed when Price is less than PTR
    // if (
    //   !isDiscountEntryAllowedForPtr(price, data?.ptr) &&
    //   (Number(data?.freeQty) > 0 || Number(discountAmount) > 0 || Number(discountPercentage) > 0)
    // ) {
    //   toast({
    //     description: `${selectedPriceIdentifier?.key === "SCHEME" ? "Free Qty" : "Discount Amount and Discount Percent"} are not allowed when Price is less than PTR`,
    //     variant: "destructive",
    //   });
    //   return;
    // }
    if (Number(data?.freeQty) < 0 || !Number.isInteger(Number(data?.freeQty))) {
      toast({
        description: `Free Quantity can not be decimal or less than 0`,
        variant: "destructive",
      });
      return;
    }
    if ((Number(data?.freeQty) <= 0 || !Number.isInteger(Number(data?.freeQty))) && Number(quantity) <= 0) {
      toast({
        description: `Required Quantity or Free Quantity`,
        variant: "destructive",
      });
      return;
    }
    if (Number(quantity) < 0) {
      toast({
        description: `Quantity cannot be less than or equal to 0`,
        variant: "destructive",
      });
      return;
    }
    if (selectedPriceIdentifier?.key === "SCHEME") {
      if (Number(data?.freeQty) < 0) {
        toast({
          description: `Free Quantity cannot be less than 0`,
          variant: "destructive",
        });
        return;
      }
    }
    if (selectedPriceIdentifier?.key === "DISCOUNT_PERCENT" || selectedPriceIdentifier?.key === "DISCOUNT_AMOUNT") {
      if (Number(data?.discountPercentage) < 0 || Number(data?.discountPercentage) > 100) {
        toast({
          description: `Discount Percentage cannot be less than 0`,
          variant: "destructive",
        });
        return;
      }
    }
    const newBatchNo = data?.batchNo?.toUpperCase() as string;
    const hasZeroMRP = priceList?.filter(item => parseFloat(item?.mrp) === data?.mrp);
    if (hasZeroMRP.length == 0 && useOrderedProducts !== "unknown") {
      toast({
        description: `Incorrect MRP. Please check`,
        variant: "destructive",
      });
      return;
    }

    try {
      const payload = {
        invoice_id: Number(invoiceDetails?.invoice?.invoice_id),
        item_description: useOrderedProducts === "unknown" ? String(data?.itemName) : String(data?.itemName),
        item_code: useOrderedProducts === "unknown" ? String(data?.itemCode) : String(data?.itemCode),
        unique_key: editingProductId || String(data?.itemCode) + selectedBatch?.batch_no,
        quantity: Number(quantity) || 0,
        gst: data?.gst || "0",
        cash_dis_perc: selectedPriceIdentifier?.key === "DISCOUNT_PERCENT" || selectedPriceIdentifier?.key === "DISCOUNT_AMOUNT" ? Number(cashDiscountPercent) : 0,
        ptr: Number(data?.ptr) || 0,
        pts: Number(data?.itemPrice?.pts) ? Number(data?.itemPrice?.pts) : Number(data?.pts) || 0, //M10-10856
        discount_type: !selectedPriceIdentifier?.description ? "Discount Amount" : String(selectedPriceIdentifier?.description),
        free_qty: selectedPriceIdentifier?.key === "SCHEME" ? Number(data?.freeQty) : 0,
        batch_no: selectedBatch?.batch_no?.toUpperCase() || newBatchNo,
        inv_rate: String(price) || "0",
        mrp_valid: true,
        inv_mrp: String(data?.mrp) || "0",
        discount_amt: !selectedPriceIdentifier?.description ? "0" : selectedPriceIdentifier?.key === "DISCOUNT_PERCENT" || selectedPriceIdentifier?.key === "DISCOUNT_AMOUNT" ? (isNaN(Number(discountAmount)) ? "0" : String(discountAmount)) : '0',
        counter_code: invoiceDetails?.counter_code,
        is_item_unknown: useOrderedProducts === "unknown",
        gross_amt: (Number(price) * Number(quantity))?.toFixed(2),
        ...(editingTextractProduct && {
          invoice_product_id: editingTextractProduct.invoice_product_id,
        }),
        ucode: generateUniqueID(),
        id: editingTextractProduct?.id  //Add for serial No
      };
      setEditingTextractProduct([]);
      setMappedData((prev) => [...prev, payload]);
      if (newBatchNo && !batchList.some((batch) => batch.batch_no === newBatchNo)) {
        setUnknownBatch((prev) => [...prev, { batch_no: newBatchNo }]);
      }
      resetFormFields();
      setSelectedBatch({});
      setEditingProductId(null);
      setIsEditingProduct(false);
      // setBatchNo("");
      // Focus the item name field after form submission
      const itemNameField = document.querySelector('input[name="itemName"]');
      if (itemNameField instanceof HTMLElement) {
        itemNameField?.focus();
      }
      setIsSaoCheck(false)
      //M10-12866
      if (invoiceDetails.upload_type === "NMV") {
        setUseOrderedProducts("company");
      } else if ((invoiceDetails.module_code === 4 || invoiceDetails.upload_type === "INST") && invoiceDetails?.orderCodes?.length == 0) {
        setUseOrderedProducts("company");
      } else {
        setUseOrderedProducts("ordered");
      }
      //M10-12866
    } catch (error) {
      console.log(error);
    }
  };

  const handleCashDiscountPercentChange = (value: string) => {
    const percent = parseFloat(value) || 0;
    setCashDiscountPercent(Number(percent?.toFixed(2)));
    setMappedData((prev) => {
      const updatedData = prev.map((item) => ({ ...item, p_cash_discount_perc: Number(percent?.toFixed(2)) }));
      return updatedData;
    });
    const discountAmount = (calculateSubtotal() * percent) / 100;
    setCashDiscountAmount(Number(discountAmount?.toFixed(2)));

    updateTotal(discountAmount);
  };

  const handleCashDiscountAmountChange = (value: string) => {
    const amount = parseFloat(value) || 0;
    setCashDiscountAmount(Number(amount?.toFixed(2)));

    const percent = (amount / calculateSubtotal()) * 100;
    setCashDiscountPercent(Number(percent?.toFixed(2)));

    setMappedData((prev) => {
      const updatedData = prev.map((item) => ({ ...item, p_cash_discount_perc: Number(percent?.toFixed(2)) }));
      return updatedData;
    });

    updateTotal(amount);
  };

  const updateTotal = (discountAmount: number) => {
    return (calculateSubtotal() - discountAmount).toFixed(2);
  };
  //M10-9685-MRP Related Issue - Add for serial No(sort & id)
  const rowsForItemsAddedTable = (isUnknown: boolean) => {
    const rows: any[] = [];
    mappedData?.length > 0 &&
      mappedData
        ?.filter((item: any) => isUnknown ? (item?.is_item_unknown === true || item?.item_code === "OTHERS") : (item?.is_item_unknown === false && item?.item_code !== "OTHERS"))
        ?.sort((a: any, b: any) => (a?.textractProduct?.stockistfile_detail_code || 0) - (b?.textractProduct?.stockistfile_detail_code || 0))
        .forEach((element: any) => {
          let modElement = JSON.parse(JSON.stringify(element));
          //Update discount_type based on free_qty
          if (modElement?.free_qty > 0) {
            modElement.discount_type = "Scheme";
          }
          modElement.textractProduct = "";
          modElement.textract_mrp = element?.textractProduct?.mrp;
          modElement.id = element?.textractProduct?.stockistfile_detail_code ? element?.textractProduct?.stockistfile_detail_code : element.id;
          rows.push(flattenObject(modElement));
        });
    return rows;
  };
  const fetchInvoiceDetails = async () => {
    setIsLoading(true);
    try {
      const response = await getInvoiceDetails(stockist_invoice_attachment_id as string, false, company_code); //M10-9862
      dispatch(invoiceActions.setInvoiceDetails(response?.data?.data));

      if (invoicesTextractData?.length > 0) {
        //M10-9685-MRP Related Issue
        //M10-14155: unknown items have no MRP master to validate against — treat as valid on landing
        const data = response?.data?.data?.invoice?.invoiceProducts?.map((item: any) => ({
          ...item,
          unique_key: item?.invoice_product_id,
          mrp_valid: (item?.is_item_unknown === true || item?.item_code === "OTHERS") ? true : item?.mrp_valid,
          is_item_unknown: item?.item_code === "OTHERS" ? true : item?.is_item_unknown,
          gross_amt: (Number(item?.inv_rate) * Number(item?.quantity)).toFixed(2),  //M10-14994
        }));
        // setMappedData(invoicesTextractData);
        setMappedData(data || []);
      } else if (response?.data?.data?.invoice?.invoiceProducts?.length > 0) {
        //M10-14155: unknown items have no MRP master to validate against — treat as valid on landing
        setMappedData(
          response?.data?.data?.invoice?.invoiceProducts?.map((item: any) => ({
            ...item,
            mrp_valid: (item?.is_item_unknown === true || item?.item_code === "OTHERS") ? true : item?.mrp_valid,
            is_item_unknown: item?.item_code === "OTHERS" ? true : item?.is_item_unknown,
            gross_amt: (Number(item?.inv_rate) * Number(item?.quantity)).toFixed(2),  //M10-14994
          })) || []
        );
        // REJECTION-REVIEW-WORKFLOW: skip the auto-redirect to Product Mapping
        // when the reviewer is opening this invoice from the FUID Rejection tab,
        // or when opening a view-only invoice (e.g. status 2).
        if (!(response?.data?.data?.is_rejection_pending || fuidRejectionReviewMode || viewOnly)) {
          navigate(`/transactions/invoice/product-mapping/${stockist_invoice_attachment_id}`);
        }
      } else {
        setMappedData([]);
      }
      if (invoicesTextractData?.length == 0) {
        dispatch(
          invoiceActions.setInvoicesTextractData(
            response?.data?.data?.invoice?.invoiceProducts?.map((item: any) => ({
              invoice_product_id: item?.invoice_product_id,
              unique_key: item?.invoice_product_id,
              invoice_id: response?.data?.data?.invoice?.invoice_id,
              item_description: item?.item_description,
              textractProduct_item_description: item?.textractProduct?.item_description,
              item_code: item?.item_code,
              quantity: item?.quantity,
              gst: item?.p_gst_perc,
              cash_dis_perc: Number(item?.p_cash_discount_perc) ?? 0,
              ptr: Number(item?.ptr),
              pts: Number(item?.pts), //M10-10856
              discount_type: item?.discount_type,
              free_qty: item?.free_qty,
              batch_no: item?.batch_no,
              inv_rate: String(item?.inv_rate),
              inv_mrp: String(item?.inv_mrp),
              discount_amt: String(item?.discount_amt),
              counter_code: response?.data?.data?.counter_code,
              is_item_unknown: item?.item_code === "OTHERS" ? false : item?.is_item_unknown,  //M10-14999
              gross_amt: String((Number(item?.ptr) * Number(item?.quantity))?.toFixed(2)),
              id: item?.textractProduct?.stockistfile_detail_code,  //Add for serial No
            })) || []
          )
        );
      }
      const isEwayExempt = response?.data?.data?.orderCodes?.filter((codes: any) => codes?.reference_order?.novu_metadata?.e_way_required)?.every((code: any) => code?.reference_order?.eway_exempt === true);
      setEwayExempt(isEwayExempt);

      if (response?.data?.data?.eWayBillDtl?.einvoice_status !== "accepted" && !isEwayExempt) {
        setIsEwayApplicable(response?.data?.data?.is_eway_applicable);
      }
      if (response?.data?.data?.invoice?.cash_discount) {
        const invoice = response?.data?.data?.invoice;
        let cashDiscount = Number(invoice?.cash_discount);
        // Trust the backend's own cash_discount_perc instead of deriving it from
        // cash_discount / total — deriving it is fragile when an item has inv_rate 0
        // (e.g. a Textract gap), which silently drops that item's value out of `total`
        // and inflates the derived percentage.
        let discountPercentage = Number(invoice?.cash_discount_perc) || 0;

        if (!discountPercentage) {
          let total = 0; //M10-10754 Start
          invoice?.invoiceProducts?.forEach((item: any) => {
            const percentage = Number(item?.discount_perc) / 100 || 0;
            const quantity = Number(item?.quantity) || 0;
            const rate = Number(item?.inv_rate) || 0;
            const gross = rate * quantity;

            const discountAmount = percentage * quantity * rate;

            const discount = !isNaN(Number(item?.discount_amt)) && Number(item?.discount_amt) !== 0
              ? Number(item.discount_amt)
              : Number(discountAmount.toFixed(2)) || 0;

            // Skip items where gross_amt is not a number or is 0
            if (!gross || isNaN(gross)) return;

            total += gross - (isNaN(discount) ? 0 : discount);
          });//M10-10754 - end

          if (cashDiscount === 0) {
            const cashDiscountPercentages = invoice?.invoiceProducts
              ?.filter((item: any) => item?.discount_type === 'Scheme')
              ?.map((item: any) =>
                Number(item?.textractProduct?.cashdiscount_percentage) || 0
              )
              .filter((val: number) => val > 0);

            // Check if all values are same
            const isSame = cashDiscountPercentages?.every(
              (val: number) => val === cashDiscountPercentages[0]
            );

            if (isSame && cashDiscountPercentages?.length > 0) {
              discountPercentage = cashDiscountPercentages[0];

              // Calculate cash discount amount
              cashDiscount =
                total !== 0
                  ? Number(((discountPercentage / 100) * total).toFixed(2))
                  : 0;
            }
          } else {
            discountPercentage =
              total !== 0
                ? Number(((cashDiscount / total) * 100).toFixed(2))
                : 0;
          }
        }
        setCashDiscountAmount(cashDiscount);
        setCashDiscountPercent(discountPercentage);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  //M10-11001
  function validate(value: any) {
    const regex = /^(?:\d{1,2})(?:\.\d{1,2})?$/;
    return regex.test(value);
  }
  //M10-11001

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };
  const isRequestInProgress = useRef(false);
  // M10-15732: with 100+ line items, clicking Edit far down the Items Added / Unknown Order table
  // used to leave the user scrolled away from the Invoice Details form where the edited values
  // actually appear — scroll it back into view whenever an item is opened for editing.
  const invoiceDetailsSectionRef = useRef<HTMLDivElement>(null);
  const scrollToInvoiceDetails = () => {
    invoiceDetailsSectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const handleSubmitInvoice = useDebounceLeading(async () => {
    if (isRequestInProgress.current) return;
    isRequestInProgress.current = true;
    setConfirmingInvoice(true);
    try {
      await withEventCheck(() => { }, `invoice_${invoiceDetails?.invoice?.invoice_id}`, invoiceDetails?.company_code); //M10-12758
      const invoiceActionAllowedResponse = await getInvoiceActionAllowed(
        invoiceDetails?.invoice?.invoice_id,
        invoiceDetails?.stockist_invoice_attachment_id,
        "Entry",
        invoiceDetails?.company_code
      );
      if (!invoiceActionAllowedResponse?.data?.data?.allowed) {
        toast({ description: invoiceActionAllowedResponse?.data?.data?.message, variant: "destructive" });
        return;
      }
      //M10-11001
      if (!validate(cashDiscountPercent)) {
        toast({ description: "Discount percentage must be up to 2 digits and 2 decimal places.", variant: "destructive" });
        return;
      }
      //M10-11001
      if (
        invoiceDetails?.invoice?.new_invoice_date == undefined ||
        invoiceDetails?.invoice?.new_invoice_date == "" ||
        invoiceDetails?.invoice?.new_invoice_date == null ||
        invoiceDetails?.invoice?.new_invoice_date == " "
      ) {
        toast({ description: "Select Invoice Date before updating", variant: "destructive" });
        return;
      }
      const calculatedTotal = calculateTotal();
      const difference = Math.abs(Number(calculatedTotal) - Number(netInvoiceAmount));
      //M10-9685-MRP Related Issue
      const newArrayWithoutUniqueKey = mappedData
        ?.map(({ unique_key, ...rest }) => rest)
        ?.map((invoice) => {
          const val = (Number(invoice?.discount_amt) / (Number(invoice?.inv_rate) * Number(invoice?.quantity))) * 100;
          //M10-11001
          if (invoice.discount_type !== "Scheme") {
            const discountPerc = invoice?.discount_perc ? invoice?.discount_perc : (isNaN(val) ? "0.00" : val.toFixed(2));
            // Skip if both are empty/zero
            if (!validate(discountPerc)) {
              toast({
                description: "Discount percentage must be up to 2 digits and 2 decimal places.",
                variant: "destructive",
              });
              return;
            }
          }
          //M10-11001
          //M10-14155: unknown product submit — match display fallback (inv_mrp→textract_mrp, ptr→inv_rate when 0)
          const isUnknownItem = invoice?.is_item_unknown === true || invoice?.item_code === "OTHERS";
          const resolvedInvMrp = isUnknownItem && !(Number(invoice?.inv_mrp) > 0)
            ? String(invoice?.textractProduct?.mrp || "0")
            : invoice?.inv_mrp;
          const resolvedPtr = isUnknownItem && Number(invoice?.ptr) === 0
            ? Number(invoice?.inv_rate)
            : Number(invoice?.ptr);
          return {
            ...invoice,
            invoice_id: Number(invoiceDetails.invoice?.invoice_id),
            cash_dis_perc: invoice?.cash_dis_perc != null ? Number(invoice.cash_dis_perc) : Number(invoice?.p_cash_discount_perc),
            discount_perc: invoice?.discount_perc ? invoice?.discount_perc : (isNaN(val) ? "0.00" : val.toFixed(2)), //M10-10754
            ptr: resolvedPtr,
            inv_mrp: resolvedInvMrp,
            batch_no: invoice?.batch_no.replace(/\s+/g, "").trim(), //M10-11021
            pts: Number(invoice?.pts), //M10-10856
            ...(invoice?.textractProduct && {
              stockistfile_detail_code: {
                stockistfile_detail_code: invoice?.textractProduct?.stockistfile_detail_code,
              },
            }),
          };
        });
      //M10-9685-MRP Related Issue
      //M10-14155: require at least one ordered/company product — block submit if every item is unknown/OTHERS
      const allUnknown = newArrayWithoutUniqueKey?.length > 0 && newArrayWithoutUniqueKey?.every(
        (item: any) => item?.is_item_unknown === true || item?.item_code === "OTHERS"
      );
      if (allUnknown) {
        toast({
          description: "Please select atleast one Ordered Products or Company Products",
          variant: "destructive",
        });
        return;
      }
      const isValid = validateInvoiceProducts(newArrayWithoutUniqueKey);
      if (!isValid) {
        return;
      }

      // M10-15166: Price cannot exceed PTR by more than 5% (checked across all products)
      const priceExceedsPtrItem = newArrayWithoutUniqueKey?.find((item: any) =>
        isPriceExceedingPtr(item?.inv_rate, item?.ptr)
      );
      if (priceExceedsPtrItem) {
        toast({
          description: `Price cannot exceed PTR by more than 5% for item ${priceExceedsPtrItem?.item_description || priceExceedsPtrItem?.item_code}.`,
          variant: "destructive",
        });
        return;
      }

      //M10-14735: Free Qty / Discount Amount / Discount Percent must be consistent with Price-vs-PTR and discount_type
      const invalidDiscountItem = newArrayWithoutUniqueKey?.find((item: any) => {
        // const itemPrice = Number(item?.inv_rate);
        // const itemPtr = Number(item?.ptr);
        const freeQty = Number(item?.free_qty);
        const discountAmt = Number(item?.discount_amt);
        const discountPerc = Number(item?.discount_perc);

        // const priceVsPtrInvalid = !isDiscountEntryAllowedForPtr(itemPrice, itemPtr) && (freeQty > 0 || discountAmt > 0 || discountPerc > 0);
        const schemeInvalid = item?.discount_type === "Scheme" && (discountAmt > 0 || discountPerc > 0);
        const discountTypeInvalid =
          (item?.discount_type === "Discount Percent" || item?.discount_type === "Discount Amount") && freeQty > 0;

          return schemeInvalid || discountTypeInvalid;
      });
      if (invalidDiscountItem) {
        toast({
          description: `Please confirm only one scheme value (Discount, Scheme, or Net Rate) for item ${invalidDiscountItem?.item_description || invalidDiscountItem?.item_code}.`,
          variant: "destructive",
        });
        return;
      }

      const result = newArrayWithoutUniqueKey?.filter(item => item?.mrp_valid == false);
      if (result.length > 0) {
        toast({
          description: `Incorrect MRP. Please check`,
          variant: "destructive",
        });
        return;
      }

      const checkScheme = newArrayWithoutUniqueKey?.filter(item => Number(item?.quantity) <= 0 && Number(item?.free_qty) <= 0);
      if (checkScheme.length > 0) {
        toast({
          description: `Required Quantity or Free Quantity`,
          variant: "destructive",
        });
        return;
      }
      //netAmount=0
      const allZero = newArrayWithoutUniqueKey?.every(item => Number(item?.quantity) === 0);
      console.log(allZero, isNetAmount)
      if (allZero && isNetAmount?.confirm === false) {
        setIsNetAmount((prev: any) => ({ ...prev, status: true }));
        return
      }
      //netAmount=0

      const resultPrice = newArrayWithoutUniqueKey?.filter(item => item?.inv_rate == '' || item?.inv_rate == undefined || item?.inv_rate == null || item?.inv_rate == '0');
      if (resultPrice.length > 0) {
        toast({
          description: `Incorrect Price. Please check ${resultPrice[0].item_description}`,
          variant: "destructive",
        });
        return;
      }
      const resultModel = newArrayWithoutUniqueKey
        ?.filter(item =>
          item?.is_item_unknown !== true && //M10-14155: skip scheme-confirmation popup for unknown items
          item?.discount_type === "Scheme" &&
          Number(item?.discount_amt) === 0 &&
          Number(item?.discount_perc) === 0 &&
          Number(item?.free_qty) === 0
        );

      const resultModelTEST = resultModel
        ?.every(item => item?.isTrue == true);

      if (resultModelTEST) {
        setIsApprovalCheck(false)
      }

      if (resultModel.length > 0 && isApprovalCheck) {
        setIsModalOpen(true)
        for (let i = 0; i < resultModel.length; i++) {
          const updatedMappedData = mappedData.map(obj =>
            obj.ucode === resultModel[i].ucode
              ? { ...obj, isTrue: obj.isTrue ?? false }
              : obj
          );

          setMappedData(updatedMappedData);
        }
        setInvalidItem(
          resultModel?.map(item => ({
            ...item,
            isTrue: item.isTrue ?? false
          }))
        );
        return
      }

      if (!netInvoiceAmount) {
        toast({
          description: `Please enter net amount`,
          variant: "destructive",
        });
        return;
      }

      if (difference > 10) {
        toast({
          description: `The difference between calculated amount and net amount should not exceed ₹10`,
          variant: "destructive",
        });
        return;
      }

      if (mappedData?.length === 0) {
        toast({
          description: `Please add at least one product`,
          variant: "destructive",
        });
        return;
      }
      //M10-10639
      try {
        const checkFullyInvoicedRes = await getCheckFullyInvoiced(
          invoiceDetails?.invoice?.invoice_id,
          invoiceDetails?.company_code,
          newArrayWithoutUniqueKey?.map((item) => ({ ...item, p_cash_discount_perc: item.cash_dis_perc.toFixed(2) }))
        );
        if (!checkFullyInvoicedRes?.data?.data?.fullyInvoiced && checkFullyInvoicedRes?.data?.data?.data?.length > 0 && !isSaoCheck) {
          setIsModalSOAOpen(true)
          setIsSaoData(checkFullyInvoicedRes?.data?.data?.data)
          return
        }
      } catch (error) {
        console.log(error)
      }


      const currentDate = new Date(invoiceDetails?.invoice?.new_invoice_date);
      const invoiceAccYear = getFinancialYear(currentDate);

      const payloadToValidateInV1 = {
        cmpstockistcode: invoiceDetails?.company_stockist_code,
        invoicenumber_searchcolumn: invoiceDetails?.invoice?.invoice_number || "",
        invoice_accyear: invoiceAccYear,
        company_code: invoiceDetails?.company_code,
      };

      const response = await getInvoiceChangeValidationV1(payloadToValidateInV1);
      if (response?.data?.success !== "success") {
        toast({ description: response?.data?.message, variant: "destructive" });
        setIsLoading(false);
        setConfirmingInvoice(false);
        return;
      }

      const payload2 = {
        data: {
          invoice_id: Number(invoiceDetails.invoice?.invoice_id),
          invoice_number: invoiceDetails?.invoice?.invoice_number,
          cash_discount_perc: String(cashDiscountPercent),
          cash_discount: String(cashDiscountAmount),
          net_amount: netInvoiceAmount,
          stockist_invoice_attachment_id: invoiceDetails?.stockist_invoice_attachment_id,
          // gst_perc: response?.data?.data?.invoice?.gst_perc || "",
          gst_amount: calculateTotalGst()?.toFixed(2),
          gross_amount: String(calculateSubtotal()),
          tcs: String(tcs) || 0,
          tcs_perc: Number(tcs) || 0,
          gst_perc: (calculateSubtotal() === 0) ? "0.00" : ((calculateTotalGst() / calculateSubtotal()) * 100).toFixed(2), // netAmount 0
          tcs_amt: ((calculateSubtotal() - (calculateSubtotal() * cashDiscountPercent) / 100 + calculateTotalGst()) * tcs) / 100,
          confirm: true,
          stockist_id: invoiceDetails?.stockist_id,
          is_manual_discount: cashDiscountAmount > 0,
          // invoice header details sending for backend versioning
          u_code: invoiceDetails?.invoice?.u_code,
          new_invoice_date: invoiceDetails?.invoice?.new_invoice_date,
          // ...(qrIRN?.trim() !== "" && { e_inv_ref_type: qrIRN }),
          e_inv_ref_type: invoiceDetails?.invoice?.e_inv_ref_type || null,
          irn: invoiceDetails?.invoice?.irn,
          gst_validated: invoiceDetails?.invoice?.gst_validated,
          dl_validated: invoiceDetails?.invoice?.dl_validated,
          mci_validated: invoiceDetails?.invoice?.mci_validated,
          counter_gst_number: invoiceDetails?.counter_gst_number || "",
          counter_dl_number: invoiceDetails?.counter_dl_number || "",
          counter_mci_number: invoiceDetails?.counter_mci_number || "",
          invoice_num_modified: false,
          counter_data_validation: false,
          invoiceProducts: newArrayWithoutUniqueKey,
          textract: invoiceDetails?.invoice?.textract,
        },
        primary_key: Number(invoiceDetails?.invoice?.invoice_id),
        event_type: "INVOICE_EDIT",
      };
      const res = await entryInvoice(payload2, company_code);

      // const response = await withEventCheck(
      //   () => {
      //     return getInvoiceDetails(stockist_invoice_attachment_id as string, false);
      //   },
      //   res?.data?.data?.invoice?.eventStreamCreated?.streamId
      // );
      // dispatch(invoiceActions.setInvoiceDetails(response?.data?.data));
      toast({ description: "Invoice confirmed successfully", variant: "default" });

      try {
        // const payload = {
        //   data: newArrayWithoutUniqueKey,
        //   primary_key: Number(invoiceDetails?.invoice?.invoice_id),
        //   event_type: "INVOICE_PRODUCT_ADD",
        // };
        // const res = await updateInvoice(payload);
        const response = await withEventCheck(
          () => {
            return getInvoiceDetails(stockist_invoice_attachment_id as string, false, company_code);
          },
          res?.data?.data?.[res?.data?.data]?.eventStreamCreated?.streamId,
          company_code  //M10-12758
        );
        dispatch(invoiceActions.setInvoiceDetails(response?.data?.data));
        resetFormFields();
        setIsLoading2(false);
        navigate("/transactions/invoice");
      } catch (error: any) {
        console.log(error);
        toast({ description: error?.response?.data?.message, variant: "destructive" });
        setConfirmingInvoice(false);
        setIsLoading2(false);
      }
    } catch (error: any) {
      console.log(error, "error");
      // M10-15822: an "Others"-mapped line whose description carries one of this company's own
      // brands blocks the confirm outright. This is the only point where a mapping REPLAYED from
      // stockist_product_mapping onto a fresh invoice becomes visible to an operator, so it gets
      // the full modal rather than a toast that scrolls away.
      const errorData = error?.response?.data;
      if (errorData?.error === "OTHERS_BRAND_MATCH_BLOCKED" && errorData?.details?.matches?.length) {
        setBrandConflictMatches(errorData.details.matches);
      } else {
        toast({ description: error?.response?.data?.message, variant: "destructive" });
      }
      setIsLoading2(false);
    } finally {
      isRequestInProgress.current = false;
      setConfirmingInvoice(false);
      setIsLoading2(false);
    }
  }, 1000);

  const fetchProductsDataForItemCode = async (query: string) => {
    if (useOrderedProducts === "unknown") {
      return;
    }
    try {
      return await getSimilarCompanyProducts(invoiceDetails?.company_code, "", query, 1, 10, isKam);  //M10-12866
    } catch (error) {
      console.log(error);
    }
  };

  const fetchOrderedProductsByItemCode = async (query: string) => {
    if (useOrderedProducts === "unknown") {
      return;
    }
    try {
      return await getOrderedProducts({
        product_name: "",
        counter_code: invoiceDetails?.counter_code,
        item_code: query,
        page: 1,
        page_size: 10,
        company_stockist_code: invoiceDetails?.company_stockist_code,
        invoice_date: invoiceDetails?.invoice?.new_invoice_date,
        company_code: invoiceDetails?.company_code,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handlePercentageChange = (e?: any) => {
    const { setValue }: any = smartFormInstance;
    const percentage = Number(e) / 100;
    const discountAmount = percentage * quantity * price;
    setDiscountAmount(Number(discountAmount?.toFixed(2)));
    setDiscountPercentage(Number(e));
    setValue("discountAmount", discountAmount?.toFixed(2));
    setValue("discountPercentage", Number(e));
  };

  const handleAmountChange = (e?: any) => {
    const { setValue }: any = smartFormInstance;
    const amount = Number(e);
    const discountPercentage = (amount / (quantity * price)) * 100;
    setDiscountAmount(amount);
    setDiscountPercentage(Number(discountPercentage?.toFixed(2)));
    setValue("discountAmount", amount);
    setValue("discountPercentage", discountPercentage?.toFixed(2));
  };

  // const handleBatchNo = (e?: any) => {
  //   setBatchNo(e);
  // };

  const handleAutocompleteChange = async (data: any) => {
    const { setValue }: any = smartFormInstance;
    const value = data;
    if (value) {
      const { isCustom } = value;
      !isCustom && setValue("itemName", value?.product_name);
      !isCustom && setValue("itemCode", value?.item_code);
      // setValue("mrp", value?.mrp || "");
      // setValue("price", value?.ptr || "");
      setPrice(value?.ptr);
      setValue("batchNo", "");
      setValue("discountAmount", "");
      setValue("discountPercentage", "");
      setValue("freeQty", "");
      setValue("quantity", "");
      setValue("schemeType", "");
      setValue("gst", "");
      setValue("itemPrice", "");
      setValue("price", "");
      setValue("ptr", "");
      setDiscountPercentage(0);
      setDiscountAmount(0);

      setItemCode(value?.item_code);
    } else {
      // setValue("mrp", "");
      // setValue("price", "");
      setValue("schemeType", "");
      setValue("freeQty", "");
      setValue("discountPercentage", "");
      setValue("discountAmount", "");
      setValue("batchNo", "");
      setValue("itemCode", "");
    }
  };

  const resetFormFields = () => {
    const { reset }: any = smartFormInstance;

    // Reset form fields
    reset();

    // Clear additional state values
    setQuantity(0);
    setPriceList([]);
    setPrice(0);
    setBatchList([]);
    setDiscountPercentage(0);
    setDiscountAmount(0);
    setSelectedPriceIdentifier({
      key: "",
      description: "",
      priceldentifier_id: 0,
    });
    setFetchTrigger(fetchTrigger + 1);
    // setTimeout(() => {
    //   // Focus the Item Name input using the input's ID
    //   const itemNameInput = document.querySelector('[name="itemName"]') as HTMLInputElement;
    //   if (itemNameInput) {
    //     itemNameInput.focus();
    //   }
    // }, 0);
  };

  const handleRadioButtonsForForm = (value: string) => {
    setUseOrderedProducts(value);
    resetFormFields();
  };

  /**
   * Calculates the total invoice amount including GST and discounts
   * Formula: Sum of [(Gross Amount - Discount) + GST] for each item
   * @returns {number} Total invoice amount
   */
  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const amountAfterCashDiscount = subtotal - (subtotal * cashDiscountPercent) / 100;
    const totalGst = calculateTotalGst();
    const tcsCalculatedAmount = amountAfterCashDiscount + totalGst + ((amountAfterCashDiscount + totalGst) * tcs) / 100;
    // return amountAfterCashDiscount + totalGst;
    return tcsCalculatedAmount;
  };

  /**
   * Calculates the raw subtotal before any discounts or taxes
   * Simply sums up the gross amounts of all items
   * @returns {number} Subtotal amount
   */
  const calculateInitialSubtotal = () => {
    let total = 0;
    mappedData?.forEach((item: any) => {
      const percentage = Number(item?.discount_perc) / 100 || 0;//M10-10754
      const quantity = Number(item?.quantity) || 0;
      const rate = Number(item?.inv_rate) || 0;
      const discountAmount = percentage * quantity * rate;

      const gross = Number(item.gross_amt);
      const parsedDiscountAmt = Number(item?.discount_amt);
      const discount = !isNaN(parsedDiscountAmt) && parsedDiscountAmt !== 0
        ? parsedDiscountAmt
        : Number(discountAmount.toFixed(2)) || 0;//M10-10754

      // Skip items where gross_amt is not a number or is 0
      if (!gross || isNaN(gross)) return;

      total += gross - (isNaN(discount) ? 0 : discount);
    });
    return total;
  };

  /**
   * Calculates final subtotal after all discounts (including cash discount)
   */
  const calculateSubtotal = () => {
    const initialSubtotal = calculateInitialSubtotal();
    return initialSubtotal;
  };

  // const calculateGstAmount = (item: any) => {
  //   const { gross_amt, gst, discount_amt } = item;
  //   const amountAfterDiscount = Number(gross_amt) - Number(discount_amt);
  //   const gstAmount = (amountAfterDiscount * Number(gst)) / 100;
  //   return gstAmount;
  // };

  const calculateTotalGst = () => {
    let total = 0;
    mappedData?.forEach((item: any) => {
      const { gross_amt, gst, discount_amt, p_gst_perc } = item;

      // Skip items with 0 or falsy gross amount
      if (!gross_amt || Number(gross_amt) === 0) return;

      //M10-10754 - start
      const percentage = Number(item?.discount_perc) / 100 || 0;
      const quantity = Number(item?.quantity) || 0;
      const rate = Number(item?.inv_rate) || 0;

      const discountAmount = percentage * quantity * rate;

      // Ensure discount_amt is a valid number, else fall back to discountAmount or 0
      const parsedDiscountAmt = Number(discount_amt);
      const discount = !isNaN(parsedDiscountAmt) && parsedDiscountAmt !== 0
        ? parsedDiscountAmt
        : Number(discountAmount.toFixed(2)) || 0;

      //M10-10754 - end
      const amountAfterItemDiscount = Number(gross_amt) - Number(discount);
      const amountAfterCashDiscount = amountAfterItemDiscount - (amountAfterItemDiscount * cashDiscountPercent) / 100;

      const gstAmount = (amountAfterCashDiscount * Number(gst || p_gst_perc)) / 100;
      total += gstAmount;
    });
    return total;
  };

  // Check the invoice_<invoice_id> stream on load so a blocked stream shows the banner, as in InvoiceApprovalScreen
  useEffect(() => {
    if (!invoiceDetails?.invoice?.invoice_id) return;
    withEventCheck(
      () => {},
      `invoice_${invoiceDetails.invoice.invoice_id}`,
      invoiceDetails?.company_code
    ).catch(() => {});
  }, [invoiceDetails?.invoice?.invoice_id, invoiceDetails?.company_code, withEventCheck]);

  useEffect(() => {
    if (discountAmount || discountPercentage) {
      if (discountAmount) {
        handleAmountChange(discountAmount);
      } else {
        handlePercentageChange(discountPercentage);
      }
    }
  }, [quantity]);

  // Cash Discount Amount is derived from Cash Discount % (fixed rate); re-derive it whenever
  // the subtotal moves (items added/edited/removed) instead of leaving the backend snapshot stale.
  // Keyed on the computed subtotal value rather than the mappedData reference: the discount
  // handlers themselves write p_cash_discount_perc back onto mappedData (which doesn't affect
  // the subtotal), and keying on the array reference re-triggered this effect on every keystroke
  // in Cash Discount Amount, overwriting the typed value with a rounded recalculation.
  const currentSubtotalForDiscount = calculateSubtotal();
  useEffect(() => {
    if (mappedData?.length > 0 && cashDiscountPercent > 0) {
      const newAmount = Number(((currentSubtotalForDiscount * cashDiscountPercent) / 100).toFixed(2));
      setCashDiscountAmount(newAmount);
    }
  }, [currentSubtotalForDiscount]);

  /**
   * Effect hook to fetch price and batch data when item code changes
   * Only runs for known/ordered products (not unknown items)
   * Makes parallel API calls for efficiency
   */
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch both price list and batch list simultaneously
        Promise.all([
          // M10-12386
          getInvoicePriceList(itemCode).then((res: any) => {
            const list = res?.data?.data?.map((item: any) => ({
              ...item,
              gst_pc: item?.gst_pc
                ? `${item.gst_pc} %`
                : "",
            })) || [];

            setPriceList(list);
          }),
          // M10-12386
          getInvoiceBatchList(itemCode, company_code).then((res: any) => {
            const apiBatches = res?.data?.data || [];
            const combinedBatches = [...apiBatches, ...unknownBatch];
            setBatchList(combinedBatches);
          }),
        ]);
      } catch (error) {
        console.log(error);
      }
    };

    // Only fetch data if we have a valid item code and it's not an unknown product
    if (itemCode && useOrderedProducts !== "unknown") {
      fetchData();
    }
  }, [itemCode, useOrderedProducts, fetchTrigger]);

  /**
   * Effect hook to fetch initial invoice details
   * Runs once on component mount
   */

  useEffect(() => {
    if (invoicesTextractData?.length > 0) {
      const itemCodes: Set<string> = new Set();
      invoicesTextractData?.filter((item: any) => item?.gst == "0")?.map((item: any) => itemCodes.add(item?.item_code));
      const itemCodesString = Array.from(itemCodes).join(",");
      if (itemCodesString.length > 0) {
        getProductGstDetails(itemCodesString).then((response: any) => {
          const updatedData = invoicesTextractData.map((item: any) => {
            const gstDetails = response?.data?.find((gst: any) => gst?.item_code === item?.item_code);
            return {
              invoice_product_id: item?.invoice_product_id,
              unique_key: item?.invoice_product_id,
              invoice_id: invoiceDetails?.invoice?.invoice_id,
              item_description: item?.item_description,
              item_code: item?.item_code,
              quantity: item?.quantity,
              gst: item?.gst == "0" ? gstDetails?.gst_pc : item?.gst || "0",
              cash_dis_perc: item?.cash_dis_perc ?? 0,
              ptr: Number(item?.ptr) || 0,
              pts: Number(item?.pts) || 0, //M10-10856
              discount_type: item?.discount_type,
              free_qty: item?.free_qty,
              batch_no: item?.batch_no,
              inv_rate: item?.inv_rate,
              inv_mrp: item?.inv_mrp,
              discount_amt: item?.discount_amt,
              counter_code: invoiceDetails?.counter_code,
              is_item_unknown: item?.is_item_unknown,
              gross_amt: (Number(item?.ptr) * Number(item?.quantity))?.toFixed(2),
              ucode: generateUniqueID(), //M10-9682
              id: item?.stockistfile_detail_code,  //Add for serial No
            };
          });
          dispatch(invoiceActions.setInvoicesTextractData(updatedData));
          setMappedData(updatedData);
        });
      } else {
        //M10-9682
        const updatedData = invoicesTextractData.map((item: any) => ({
          ...item,
          id: item?.stockistfile_detail_code,  //Add for serial No
          ucode: generateUniqueID(),
        }));
        dispatch(invoiceActions.setInvoicesTextractData(updatedData));
        setMappedData(updatedData); //M10-9682
      }
    }
    // if (invoiceDetails?.length == 0) {
    //   fetchInvoiceDetails();
    // }
  }, []);
  //M10-12866
  useEffect(() => {
    if (!invoiceDetails) return;

    const isInstUpload = invoiceDetails.upload_type === "INST";
    const isKamModule = invoiceDetails.module_code === 4;
    const isNonMedvol = invoiceDetails.upload_type === "NMV";

    if (isNonMedvol || ((isInstUpload || isKamModule) && invoiceDetails?.orderCodes?.length == 0)) {
      setUseOrderedProducts("company");
      console.log(invoiceDetails.counter_company_location_id, "invoiceDetails.counter_company_location_id")
      setCounterCompanyLocation(invoiceDetails.counter_company_location_id)
    }

    setIsKam(invoiceDetails.module_code);
  }, [invoiceDetails]);
  //M10-12866
  //M10-9685-MRP Related Issue
  useEffect(() => {
    dispatch(invoiceActions.setInvoiceDetails([]));
    dispatch(invoiceActions.setInvoicesTextractData([]));
    resetFormFields();
    fetchInvoiceDetails();
  }, [stockist_invoice_attachment_id]);
  //M10-9685-MRP Related Issue

  const handleFormSubmit = async (payload: any): Promise<boolean> => {
    setLoading(true);
    try {
      const finalPayload = {
        ...payload,
        reference_number: `Entry-${payload.reference_number}`,
      };
      
      const res = await addFeedback(finalPayload);

      if (res?.status === 200) {
        toast({ description: "Feedback submitted successfully" });
        return true;
      } else {
        toast({
          variant: "destructive",
          description: res?.data?.message || "Failed to submit feedback",
        });
        return false;
      }
    } catch (err: any) {
      toast({
        variant: "destructive",
        description: err?.message || "Failed to submit feedback",
      });
      return false;
    } finally {
      setIsFeedbackModalOpen(false);
      setLoading(false);
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  // REJECTION-REVIEW-WORKFLOW: restricted view for reviewers — Invoice Details
  // card + Accept/Reject only. No entry form, item table, or Confirm Invoice.
  if (isInRejectionReview) {
    return (
      <InvoiceLayout>
        <div className="flex justify-between px-[3.75rem] mt-6 pb-12 shadow-md border-b-[1px] border-b-[#E9E9E9]">
          <div className="flex items-center justify-between w-full">
            <div className="flex flex-col">
              <div
                className="flex items-center cursor-pointer font-semibold px-0 py-2 text-lg text-[#7F56D9]"
                onClick={() => navigate("/transactions/invoice/0")}
              >
                <img src={PurpleLeftArrowIcon} alt="back" className="w-3 h-3 mr-3" />
                Back to Invoices
              </div>
              <h1 className="text-[#49484C] font-bold text-[2rem]">FUID Rejection Review</h1>
            </div>
          </div>
        </div>
        <div className="px-[3.75rem] mx-auto mt-10 relative">
          <div className="mb-4 p-3 rounded-lg border border-[#FCD34D] bg-[#FFFBEB] text-[#92400E] text-sm font-medium">
            This invoice has a pending rejection. As the assigned reviewer you can <b>Accept</b> the
            rejection (invoice will be marked rejected) or <b>Reject</b> it (returns to the original
            user). All entry/edit actions are disabled.
          </div>
          <ul className="mt-5">
            <li className="my-5 mb-10 rounded-lg">
              <InvoiceDetailCard
                isExpandedInitial={true}
                isExpandable={false}
                status={invoiceDetails?.fileStatusHdr?.fuid_status_desc}
                checkDataType={false}
                data={getInvoiceDetailsInfo(invoiceDetails)}
                viewDetails={false}
                invoiceData={invoiceDetails}
                fetchInvoiceDetails={fetchInvoiceDetails}
                tab={0}
                isEwayExempt={isEwayExempt}
                onEwayBillPending={() => invoiceDetails?.is_eway_applicable && setIsEwayApplicable(true)} //M10-16202
                isFuidRejectionReview={true}
              />
            </li>
          </ul>
          {(invoiceDetails?.rejection_code ||
            (invoiceDetails?.rejection_data_email_desc &&
              typeof invoiceDetails.rejection_data_email_desc === "object" &&
              Object.keys(invoiceDetails.rejection_data_email_desc).length > 0)) && (() => {
              const formatKey = (key: string) =>
                key
                  .replace(/[_-]+/g, " ")
                  .replace(/([a-z])([A-Z])/g, "$1 $2")
                  .replace(/\b\w/g, (c) => c.toUpperCase());

              const isIsoDateString = (value: any) =>
                typeof value === "string" && /^\d{4}-\d{2}-\d{2}T/.test(value) && !isNaN(new Date(value).getTime());

              const formatValue = (value: any): string => {
                if (value === null || value === undefined || value === "") return "";
                if (isIsoDateString(value)) {
                  const d = new Date(value);
                  return `${d.toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  })}, ${d.toLocaleTimeString("en-GB", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}`;
                }
                if (typeof value === "object") return JSON.stringify(value, null, 2);
                return String(value);
              };

              // M10-14793: Fixed display sequence for Rejection Details; "rejected_by" and
              // "rejected_by_role" are intentionally excluded.
              const labelOverrides: Record<string, string> = {
                rejection_remark: "Rejection Remarks",
                sub_remarks: "Rejection Sub Remarks",
                rejected_at: "Rejected Date",
              };
              const orderedKeys = [
                "rejection_code",
                "rejection_header",
                "rejection_remark",
                "sub_remarks",
                "invoice_number",
                "invoice_date",
                "rejected_by_name",
                "rejected_at",
                "corrective_hint",
              ];
              const combinedData: Record<string, any> = {
                rejection_code: invoiceDetails?.rejection_code,
                ...(invoiceDetails?.rejection_data_email_desc || {}),
              };
              const excludedKeys = new Set(["rejected_by", "rejected_by_role"]);
              // Any keys beyond the fixed sequence (e.g. product name) still show up,
              // appended after Corrective Hint in whatever order the data provides.
              const extraKeys = Object.keys(combinedData).filter(
                (key) => !orderedKeys.includes(key) && !excludedKeys.has(key)
              );

              const entries = [...orderedKeys, ...extraKeys]
                .map((key): [string, any] => [key, combinedData[key]])
                .filter(([, v]) => v !== null && v !== undefined && v !== "");

              if (entries.length === 0) return null;

              return (
                <div className="mb-6 rounded-lg border border-[#FCA5A5] bg-[#FEF2F2] overflow-hidden">
                  <div className="px-5 py-3 bg-[#FEE2E2] border-b border-[#FCA5A5] flex items-center justify-between">
                    <h3 className="text-[#7F1D1D] font-semibold text-base">Rejection Details</h3>
                    <button
                      type="button"
                      onClick={() => setIsRejectionReEditOpen(true)}
                      disabled={!!reviewActionInProgress}
                      className="flex items-center gap-1 hover:text-[#1B1A1F] disabled:opacity-50 disabled:cursor-not-allowed text-[#7F1D1D] font-semibold text-base"
                      title="Edit rejection"
                    >
                      <img src={editPen} alt="edit" className="w-5 h-5" />
                      Edit
                    </button>
                  </div>
                  <div className="px-5 py-4 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 text-sm">
                    {entries.map(([key, value]) => {
                      const formatted = formatValue(value);
                      const isLong = formatted.length > 60 || /\n/.test(formatted);
                      return (
                        <div
                          key={key}
                          className={`flex flex-col ${isLong ? "md:col-span-2" : ""}`}
                        >
                          <span className="text-xs uppercase tracking-wide text-[#9B2C2C] font-semibold mb-1">
                            {labelOverrides[key] || formatKey(key)}
                          </span>
                          <span className="text-[#1B1A1F] leading-relaxed whitespace-pre-wrap break-words">
                            {formatted}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })()}
          <div className="flex items-center justify-end gap-3 mt-6 mb-10">
            <Button
              isLoading={reviewActionInProgress === "reject"}
              disabled={!!reviewActionInProgress}
              onClick={handleRejectRejection}
              className="border"
            >
              Incorrect Rejection
            </Button>
            <Button
              isLoading={reviewActionInProgress === "accept"}
              disabled={!!reviewActionInProgress}
              onClick={handleAcceptRejection}
              className="font-normal text-white bg-primary"
            >
              Correct Rejection
            </Button>
          </div>
        </div>
        <Modal
          isOpen={!!reviewModalAction}
          isHeader={false}
          onCloseModal={closeReviewModal}
          title={reviewModalAction === "ACCEPT" ? "Correct Rejection" : "Incorrect Rejection"}
        >
          <div className="flex flex-col gap-y-2 w-[500px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
            <div className="flex justify-between items-center">
              <p className="text-normal py-1 font-semibold text-[#1B1A1F]">
                {reviewModalAction === "ACCEPT" ? "Confirm Correct Rejection" : "Confirm Incorrect Rejection"}
              </p>
              <Button className="bg-transparent -mr-3" onClick={closeReviewModal}>
                <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
              </Button>
            </div>
            <p className="text-sm mt-2 font-normal text-[#666666]">Reference Number</p>
            <Input
              type="text"
              value={reviewReferenceNumber}
              onChange={(e: any) => setReviewReferenceNumber(e.target.value)}
              placeholder="Enter reference number"
              className="p-2 border bg-[#f7f7f7] border-gray-300 rounded-md"
            />
            <div className="flex justify-end gap-x-2">
              <Button
                disabled={!!reviewActionInProgress || !reviewReferenceNumber.trim()}
                isLoading={
                  (reviewModalAction === "ACCEPT" && reviewActionInProgress === "accept") ||
                  (reviewModalAction === "REJECT" && reviewActionInProgress === "reject")
                }
                loaderSize="small"
                className="text-white bg-[#8051FF] mt-4"
                onClick={() => reviewModalAction && runReviewAction(reviewModalAction)}
              >
                Proceed
              </Button>
              <Button disabled={!!reviewActionInProgress} className="bg-[#f5f5f5] mt-4" onClick={closeReviewModal}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={isRejectionReEditOpen}
          isHeader={false}
          onCloseModal={() => setIsRejectionReEditOpen(false)}
          title="Edit Rejection"
        >
          <InvoiceReject
            mode="rename"
            invoiceData={invoiceDetails}
            onCloseModal={() => setIsRejectionReEditOpen(false)}
            onSuccess={() => fetchInvoiceDetails()}
          />
        </Modal>
      </InvoiceLayout>
    );
  }

  return (
    <InvoiceLayout>
      <Fragment>
        <Transition
          as={Fragment}
          show={isRemarksShown}
          enter="transition transition ease-in-out duration-200 transform"
          enterFrom="translate-x-full"
          enterTo="translate-x-0"
          leave="transition  ease-in-out duration-200 transform"
          leaveFrom="translate-x-0"
          leaveTo="translate-x-full"
        >
          <div className="fixed right-0 inset-0 top-0 z-[500]">
            <InvoiceRemarks invoiceApprovalData={invoiceDetails} invoice_id={Number(invoiceDetails?.invoice?.invoice_id)} ref={ref} />
          </div>
        </Transition>
      </Fragment>
      <div className="flex justify-between px-[3.75rem] mt-6  pb-12 shadow-md border-b-[1px] border-b-[#E9E9E9]">
        <div className="flex items-center justify-between w-full">
          <div className="flex flex-col">
            <div
              className="flex items-center cursor-pointer font-semibold px-0 py-2 text-lg text-[#7F56D9]"
              onClick={() => navigate("/transactions/invoice/0")}
            >
              <img src={PurpleLeftArrowIcon} alt="back" className="w-3 h-3 mr-3" />
              Back to Invoices
            </div>
            <h1 className="text-[#49484C] font-bold text-[2rem]">Invoice Entry</h1>
          </div>
        </div>
        {/* //M10-11601 */}
        <div className="absolute right-4 flex flex-row gap-3 items-end mt-24">
          <div
            onClick={() => setIsFeedbackModalOpen(true)}
            className="p-2 bg-white cursor-pointer"
          >
            <MessageSquareText className="text-gray-500 h-6 w-6" />
          </div>

          {/* Versioning */}
          <div
            onClick={() => setVersioningModal((prev) => !prev)}
          >
            <img src={Book} alt="Version" className="h-10 w-14 " />
          </div>

          {/* Remarks */}
          {viewRemarks && (
            <div
              onClick={() => setIsRemarksShown(true)}
              className="p-2 bg-white cursor-pointer"
            >
              <MessageCircle className="text-gray-500 h-6 w-6" />
            </div>
          )}
        </div>

      </div>
      {isInvoiceEventBlocked && (
        <div
          className="py-0.5"
          style={{
            width: "100%",
            backgroundColor: "rgba(117, 80, 250, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              color: "#7450FA",
              fontSize: "16px",
              fontWeight: "bold",
              textShadow: "1px 1px 2px #FFFFFF",
              padding: "6px 0",
            }}
          >
            We regret to inform you, The event has been "blocked" due to too many rigorous events in Queue.
          </p>
        </div>
      )}
      <div className="px-[3.75rem] mx-auto mt-10 relative">
        {VersioningModal && (
          <div ref={outSideClickRef}>
            <VersioningCrate type="Invoice" invoiceId={invoiceDetails?.invoice?.invoice_id} stockistInvAttachmentId={invoiceDetails?.stockist_invoice_attachment_id} />
          </div>
        )}
        <ul className="mt-5">
          <li className="my-5 mb-10 rounded-lg">
            <InvoiceDetailCard
              isExpandedInitial={true}
              isExpandable={false}
              status={invoiceDetails?.fileStatusHdr?.fuid_status_desc}
              checkDataType={false}
              data={getInvoiceDetailsInfo(invoiceDetails)}
              viewDetails={false}
              invoiceData={invoiceDetails}
              // handleAddItem={handleAddItem}
              fetchInvoiceDetails={fetchInvoiceDetails}
              tab={0}
              isEwayExempt={isEwayExempt}
              onEwayBillPending={() => invoiceDetails?.is_eway_applicable && setIsEwayApplicable(true)} //M10-16202
            />
          </li>
        </ul>
        {invoiceDetails?.invoice && (
          <div className="p-0 mb-10 border-2 rounded-lg" ref={invoiceDetailsSectionRef}>
            <div className="m-5">
              <div className="flex items-center justify-between">
                <p className="mb-2 text-lg font-semibold">Invoice Details</p>
                <Button className="w-10 h-10 bg-[#F1F1F1] border border-1-black" onClick={handleToggle}>
                  <img className={`transition-transform duration-300 ${isExpanded ? "rotate-180" : ""}`} src={downArrow} alt="down-arrow" />
                </Button>
              </div>
              <div className="flex items-center gap-x-5">
                <div className="flex items-center mb-5 space-x-6">
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="orderedProducts"
                      name="productType"
                      value="ordered"
                      checked={useOrderedProducts === "ordered"}
                      onChange={() => handleRadioButtonsForForm("ordered")}
                      className="mr-2"
                    />
                    <label htmlFor="orderedProducts" className="text-sm text-gray-500">
                      Ordered Products
                    </label>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="radio"
                      id="companyProducts"
                      name="productType"
                      value="company"
                      checked={useOrderedProducts === "company"}
                      onChange={() => handleRadioButtonsForForm("company")}
                      className="mr-2"
                    />
                    <label htmlFor="companyProducts" className="text-sm text-gray-500">
                      Company Products
                    </label>
                  </div>
                </div>
                <div className="flex items-center mb-5">
                  <input
                    type="radio"
                    id="unknownOrder"
                    name="productType"
                    value="unknown"
                    checked={useOrderedProducts === "unknown"}
                    onChange={() => handleRadioButtonsForForm("unknown")}
                    className="mr-2"
                  />
                  <label htmlFor="unknownOrder" className="text-sm text-gray-500">
                    Unknown Order
                  </label>
                </div>
              </div>
              <div
                className={`transition-all duration-500 ease-in-out ${isExpanded ? "max-h-[1000px] opacity-100" : "max-h-0 opacity-0"}`}
                style={{ transitionProperty: "max-height, opacity" }}
              >
                <InvoiceEntryForm
                  handleAddProduct={handleAddProduct}
                  smartFormInstance={smartFormInstance}
                  useOrderedProducts={useOrderedProducts}
                  handleAutocompleteChange={handleAutocompleteChange}
                  selectedPriceIdentifier={selectedPriceIdentifier}
                  setSelectedBatch={setSelectedBatch}
                  schema={schema}
                  fetchOrderedProductsByItemCode={fetchOrderedProductsByItemCode}
                  fetchProductsDataForItemCode={fetchProductsDataForItemCode}
                  batchList={batchList}
                  priceList={priceList}
                  gstAmbiguous={gstAmbiguous}
                  setGstAmbiguous={setGstAmbiguous}
                  setPrice={setPrice}
                  quantity={quantity}
                  setQuantity={setQuantity}
                  priceIdentifierList={priceIdentifierList}
                  setSelectedPriceIdentifier={setSelectedPriceIdentifier}
                  discountPercentage={discountPercentage}
                  discountAmount={discountAmount}
                  handlePercentageChange={handlePercentageChange}
                  handleAmountChange={handleAmountChange}
                  //M10-12866
                  isKam={isKam}
                  counterCompanyLocation={counterCompanyLocation}
                  //M10-12866
                  isEditing={isEditingProduct}
                />
              </div>
            </div>
          </div>
        )}
        <div className="flex flex-col mt-5 gap-x-5 [@media(min-width:1580px)]:flex-row">
          <div className="flex flex-col w-full gap-4 p-8 border rounded-lg [@media(min-width:1580px)]:w-9/12">
            <SubTable
              isLoading={isLoading2}
              title="Items Added"
              subtitle="Review and manage all items added"
              showheader={true}
              columns={columns}
              data={rowsForItemsAddedTable(false)}
              enableShowError={true}
            />
            <SubTable
              isLoading={isLoading2}
              title="Unknown Order"
              subtitle="Review and manage all items added"
              showheader={true}
              columns={columns2}
              data={rowsForItemsAddedTable(true)}
              enableShowError={true}
            />
            <Button
              className="w-fit h-9 mt-0 font-normal border border-[#D0D0D0]  bg-[#F1F1F1] shadow-sm"
              onClick={() => {
                navigate(`/transactions/invoice/product-mapping/${invoiceDetails?.stockist_invoice_attachment_id}`);
              }}
            >
              Map Products
            </Button>
          </div>

          <div className={`w-4/12 p-8 mt-10 border rounded-lg [@media(min-width:1580px)]:w-3/12 [@media(min-width:1580px)]:mt-0 ${isSpecialStockist && !isAcknowledged ? "border-red-500 bg-red-50" : ""}`}>
            <p className="mb-2 text-lg font-semibold">Calculations</p>
            <div className="flex flex-col pb-10 gap-y-1">
              <p className="flex justify-between py-2 text-sm">
                Subtotal{" "}
                <span className="">
                  ₹
                  {Number((calculateSubtotal() - cashDiscountAmount)?.toFixed(2)).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </p>
              <p className="flex justify-between py-2 text-sm">
                <span className="mr-2">Cash Discount %</span>
                <div className="">
                  <Input
                    enableArrows={false}
                    showIcon={false}
                    type="number"
                    placeholder="0"
                    value={cashDiscountPercent}
                    onChange={(e: any) => handleCashDiscountPercentChange(e?.target?.value)}
                    className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                  />{" "}
                </div>
              </p>
              <p className="flex justify-between py-2 text-sm">
                <span className="mr-2">Cash Discount Amount</span>
                <div className="">
                  <Input
                    enableArrows={false}
                    showIcon={false}
                    type="number"
                    placeholder="0"
                    value={cashDiscountAmount}
                    onChange={(e: any) => handleCashDiscountAmountChange(e?.target?.value)}
                    className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                  />{" "}
                </div>
              </p>
              <p className="flex justify-between py-2 text-sm">
                <span className="mr-2">TCS %</span>
                <div className="">
                  <Input
                    enableArrows={false}
                    showIcon={false}
                    type="number"
                    placeholder="TCS"
                    value={tcs}
                    onChange={(e: any) => setTcs(e?.target?.value)}
                    className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                  />{" "}
                </div>
              </p>
              <p className="flex justify-between py-2 text-sm">
                GST Amount
                <span className="font-semibold">
                  ₹
                  {Number(calculateTotalGst()?.toFixed(2)).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </p>
              <p className="flex justify-between py-2 text-sm">
                Total (as calculated){" "}
                <span className="font-semibold">
                  ₹
                  {Number(calculateTotal()?.toFixed(2)).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </span>
              </p>
              <p className="flex justify-between py-2 text-sm">
                <span className="mr-2">
                  Net Inv. Amt.<span className="text-red-500"> *</span>
                </span>
                <div className="">
                  <Input
                    enableArrows={false}
                    showIcon={false}
                    type="number"
                    placeholder="Net Amt."
                    value={netInvoiceAmount}
                    onChange={(e: any) => setNetInvoiceAmount(e?.target?.value)}
                    className="w-24 py-1 text-right border border-gray-300 rounded-lg"
                  />{" "}
                </div>
              </p>
              {isSpecialStockist && (
                <div className="flex items-center gap-2 py-3 text-sm">
                  <input
                    type="checkbox"
                    checked={isAcknowledged}
                    onChange={(e) => setIsAcknowledged(e.target.checked)}
                    className="w-4 h-4 accent-red-500 cursor-pointer"
                  />
                  <span className="text-red-600 font-medium">
                    I acknowledge and confirm invoice details
                  </span>
                </div>
              )}
              {/* viewOnly (e.g. status-2 invoices) opens read-only — no submit button */}
              {!viewOnly && (!isSpecialStockist || isAcknowledged) && (
                <Button
                  disabled={isRequestInProgress.current}
                  className="w-full h-9 mt-5 font-normal text-white bg-[#8051FF] shadow-sm"
                  isLoading={isConfirmingInvoice}
                  loaderSize="small"
                  onClick={handleSubmitInvoice}
                  module={fineGrainedPermissionsKeys.INVOICE.CONFIRMINVOICE.module}
                  action={fineGrainedPermissionsKeys.INVOICE.CONFIRMINVOICE.action}
                >
                  Confirm Invoice
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={isEwayApplicable} isHeader={false} onCloseModal={() => setIsEwayApplicable(false)} title="Eway Bill">
        <EwayDetails
          onSuccess={fetchInvoiceDetails}
          onCloseModal={() => {
            setIsEwayApplicable(false);
          }}
          invoiceData={invoiceDetails}
        />
      </Modal>
      <Modal isOpen={isModalOpen} isHeader={false} onCloseModal={() => setIsModalOpen(false)} title="Vertify">
        <div className="flex flex-col gap-y-2 mb-4 w-[540px] max-h-[90vh] mx-auto px-6 bg-white p-4 rounded-xl">
          <div className="flex justify-between items-center">
            <p className="text-sm font-semibold text-gray-800">
              You have not entered scheme, are you sure you want to continue?
            </p>
            <Button className="bg-transparent -mr-3" onClick={() => setIsModalOpen(false)}>
              <img src={crossIcon} alt="Close" className="w-5 h-5 invert cursor-pointer" />
            </Button>
          </div>

          {/* Scrollable Table Wrapper */}
          <div className="overflow-y-auto max-h-[400px] mt-2">
            <table className="w-full text-sm text-gray-700 border border-gray-200 rounded">
              <thead className="bg-gray-100 text-left sticky top-0 z-10">
                <tr>
                  <th className="p-2 border-b">Item Code</th>
                  <th className="p-2 border-b">Item Description</th>
                  <th className="p-2 border-b">Batch No</th>
                  <th className="p-2 border-b">Quantity</th>
                  <th className="p-2 border-b">Status</th>
                </tr>
              </thead>
              <tbody>
                {invalidItem?.map((item, index) => (
                  <tr key={index}>
                    <td className="p-3 border-b">{item?.item_code}</td>
                    <td className="p-3 border-b">{item?.item_description}</td>
                    <td className="p-3 border-b">{item?.batch_no}</td>
                    <td className="p-3 border-b">{item?.quantity}</td>
                    <td className="p-3 border-b">
                      <Toggle
                        checked={item?.isTrue}
                        onChange={(checked: boolean) => {
                          const updatedMappedData = mappedData.map(obj =>
                            obj.ucode === item.ucode
                              ? { ...obj, isTrue: checked }
                              : obj
                          );
                          const updatedMapped = invalidItem.map(obj =>
                            obj.ucode === item.ucode
                              ? { ...obj, isTrue: checked }
                              : obj
                          );
                          setMappedData(updatedMappedData);
                          setInvalidItem(updatedMapped);
                          const resultModelTEST = updatedMapped.every(item => item?.isTrue === true);

                          setIsApprovalCheck(!resultModelTEST);
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            {/* M10-11544 */}
            <Button
              className="bg-gray-300 text-gray-700 hover:bg-[#BFC5CC] px-4 py-2 rounded-lg"
              onClick={() => {
                const updatedMapped = invalidItem.map(obj => ({
                  ...obj,
                  isTrue: false
                }));
                const updatedMappedData = mappedData.map(obj => ({
                  ...obj,
                  isTrue: false
                }));
                setMappedData(updatedMappedData)
                setInvalidItem(updatedMapped);
                setIsApprovalCheck(true);
                setIsModalOpen(false);
              }}
            >
              {/* M10-11544 */}
              Cancel
            </Button>
            <Button
              loaderSize="small"
              isLoading={isLoading}
              className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
              onClick={() => { setIsModalOpen(false) }}
            >
              Proceed
            </Button>
          </div>
        </div>
      </Modal>
      {/* M10-10639 */}
      <Modal isOpen={isModalSOAOpen} isHeader={false} onCloseModal={() => setIsModalSOAOpen(false)} title="Vertify">
        <div className="flex flex-col gap-y-2 mb-4 w-[910px] max-h-[90vh] mx-auto px-6 bg-white p-4 rounded-xl">
          <div className="flex justify-between items-center">
            <p className="text-sm font-semibold text-gray-800">
              Are you sure you want to continue?
            </p>
            <Button className="bg-transparent -mr-3" onClick={() => setIsModalSOAOpen(false)}>
              <img src={crossIcon} alt="Close" className="w-5 h-5 invert cursor-pointer" />
            </Button>
          </div>

          {/* Scrollable Table Wrapper M10-11277*/}
          <div className="overflow-y-auto max-h-[400px] mt-2">
            <table className="w-full text-sm text-gray-700 border border-gray-200 rounded">
              <thead className="bg-gray-100 text-left sticky top-0 z-10">
                <tr>
                  <th className="p-2 border-b">Item Code</th>
                  <th className="p-2 border-b">Order Code</th>
                  {/* Order Details Header */}
                  <th className="p-2 border-b text-center" colSpan={3}>Order Details</th>
                  {/* Invoice Details Header */}
                  <th className="p-2 border-b text-center" colSpan={3}>Invoice Details</th>
                </tr>
                <tr>
                  <th className="p-2 border-b"></th>
                  <th className="p-2 border-b"></th>
                  <th className="p-2 border-b">Quantity</th>
                  <th className="p-2 border-b">Disc Type</th>
                  <th className="p-2 border-b">Value</th>
                  <th className="p-2 border-b">Quantity</th>
                  <th className="p-2 border-b">Disc Type</th>
                  <th className="p-2 border-b">Value</th>
                </tr>
              </thead>
              <tbody>
                {isSaoData?.map((item, index) => (
                  <tr key={index}>
                    <td className="p-3 border-b">{item?.item_code || "-"}</td>
                    <td className="p-3 border-b">{item?.order_code || "-"}</td>

                    {/* Conditionally Render Order Details */}
                    {item?.order_discount_on_ptr && (
                      <>
                        <td className="p-3 border-b">{item?.order_quantity}</td>
                        <td className="p-3 border-b">Discount On PTR</td>
                        <td className="p-3 border-b">{item?.order_discount_on_ptr || "-"}</td>
                      </>
                    )}

                    {/* Conditionally Render Invoice Details */}
                    {item?.invoice_discount_on_ptr && (
                      <>
                        <td className="p-3 border-b">{item?.invoice_quantity}</td>
                        <td className="p-3 border-b">Discount On PTR</td>
                        <td className="p-3 border-b">{item?.invoice_discount_on_ptr || "-"}</td>
                      </>
                    )}

                    {/* Conditionally Render Scheme and Fixed Price - Order */}
                    {item?.order_free_qty && (
                      <>
                        <td className="p-3 border-b">{item?.order_quantity}</td>
                        <td className="p-3 border-b">Scheme</td>
                        <td className="p-3 border-b">{item?.order_free_qty || "-"}</td>
                      </>
                    )}
                    {item?.order_fixed_price && (
                      <>
                        <td className="p-3 border-b">{item?.order_quantity}</td>
                        <td className="p-3 border-b">Fixed Price</td>
                        <td className="p-3 border-b">{item?.order_fixed_price || "-"}</td>
                      </>
                    )}

                    {/* Conditionally Render Scheme and Fixed Price - Invoice */}
                    {item?.invoice_free_qty && (
                      <>
                        <td className="p-3 border-b">{item?.invoice_quantity}</td>
                        <td className="p-3 border-b">Scheme</td>
                        <td className="p-3 border-b">{item?.invoice_free_qty || "-"}</td>
                      </>
                    )}
                    {item?.invoice_fixed_price && (
                      <>
                        <td className="p-3 border-b">{item?.invoice_quantity}</td>
                        <td className="p-3 border-b">Fixed Price</td>
                        <td className="p-3 border-b">{item?.invoice_fixed_price || "-"}</td>
                      </>
                    )}
                    {/* M10-11277 */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <Button className="bg-gray-300 text-gray-700 hover:bg-[#BFC5CC] px-4 py-2 rounded-lg" onClick={() => setIsModalSOAOpen(false)}>
              Cancel
            </Button>
            <Button
              disabled={isApprovalCheck}
              loaderSize="small"
              isLoading={isLoading}
              className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
              onClick={() => {
                setIsModalSOAOpen(false)
                setIsSaoCheck(true)
              }}
            >
              Proceed
            </Button>
          </div>
        </div>
      </Modal>
      {/* NetAmount is 0 */}
      <Modal isOpen={isNetAmount.status} isHeader={false} onCloseModal={() => setIsNetAmount((prev: any) => ({ ...prev, status: false }))} title="Vertify">
        <div className="flex flex-col gap-y-2 mb-4 w-[640px] max-h-[90vh] mx-auto px-6 bg-white p-4 rounded-xl">
          <div className="flex justify-between items-center">
            <p className="text-sm font-medium text-gray-900 leading-relaxed">
              <span className="text-yellow-800">⚠️ <strong>Warning:</strong> All product quantities are <span className="text-red-600 font-bold">0</span>. Do you still want to continue?</span>
            </p>
            <Button className="bg-transparent -mr-3" onClick={() => setIsNetAmount((prev: any) => ({ ...prev, status: false }))}>
              <img src={crossIcon} alt="Close" className="w-5 h-5 invert cursor-pointer" />
            </Button>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <Button className="bg-gray-300 text-gray-700 hover:bg-[#BFC5CC] px-4 py-2 rounded-lg" onClick={() => setIsNetAmount((prev: any) => ({ ...prev, status: false }))}>
              Cancel
            </Button>
            <Button
              loaderSize="small"
              className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
              onClick={() => setIsNetAmount((prev: any) => ({ ...prev, status: false, confirm: true }))}
            >
              Proceed
            </Button>

          </div>
        </div>
      </Modal>

      {isFeedbackModalOpen && (
        <Modal isOpen={isFeedbackModalOpen} isHeader={true} title="Feedback" onCloseModal={() => setIsFeedbackModalOpen(false)}>
          <AddFeedbackForm
            onFormSubmit={handleFormSubmit}
            defaultValues={{ reference_number: invoiceDetails?.fuid_no, type: { name: "Invoices", id: "invoice" } }}
            isLoading={loading}
          />
        </Modal>
      )}

      {/* M10-15822 — confirm blocked because an "Others"-mapped line carries one of this company's brands */}
      <BrandConflictModal
        isOpen={brandConflictMatches.length > 0}
        onClose={() => setBrandConflictMatches([])}
        matches={brandConflictMatches}
      />
    </InvoiceLayout>
  );
};
